import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TextInput = styled.input`
   font-weight: normal;
  border: 1px solid #ccc;
  width: 100%;
  font-size: 0.86em;
  padding: 5px;
  background-color: #fff;
  font-family: inherit;
  border-radius: 4px;
  &:disabled{
    background-color: ${(props) => props.dbc ? '' : 'lightgray'};
  }
  
  /* Hide number input spinners for all browsers */
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

const TextLabel = styled.div`
  font-weight: normal;
  width: 100%;
  font-size: 0.86em;
  padding: 5px;
  background-color: ${(props) => props.dbc ? '' : 'lightgray'};
  font-family: inherit;
  width: 100%;
  min-height: 32px;
  .summary-content & {
    padding: 0px;
  }
  .summary-content .expenses & {
    margin-left: 30px;
  }
`;

// export default Textbox;

export default function Textbox(props) {
  
  const handleKeyDown = (e) => {
    if (props.type === 'number') {
      // Allow: backspace, delete, tab, escape, enter, home, end, left, right, up, down
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'];
      
      // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
      if (e.ctrlKey || e.metaKey) {
        return;
      }
      
      
      // Allow navigation keys
      if (allowedKeys.includes(e.key)) {
        return;
      }
      
      // Allow only digits and optionally decimal point (if onlyNumber is false)
      const isDigit = /^\d$/.test(e.key);
      const isDecimalPoint = e.key === '.' && !props.onlyNumber;
      
      if (!isDigit && !isDecimalPoint) {
        e.preventDefault();
      }
    }
    // Call the original onKeyDown if provided
    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  };

  const handlePaste = (e) => {
    if (props.type === 'number') {
      // Get pasted data via clipboard API
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('Text');

      // Check if pasted data contains only numbers
      if (!/^\d*$/.test(pastedData)) {
        e.preventDefault();
      }
    }
  };

  if (props.disabled && !props.isSummary) {
    return <TextLabel disabled={props.disabled} className='disabled'>{props.value}</TextLabel>;
  }
  if (props.isSummary) {
    return (
      <TextLabel>{props.value || 'N/A'}</TextLabel>
    );
  }

  const { onKeyDown, ...otherProps } = props;
  return <TextInput {...otherProps} onKeyDown={handleKeyDown}  onPaste={handlePaste}/>;
}

Textbox.propTypes = {
  disabled: PropTypes.bool,
  isSummary: PropTypes.bool,
  value: PropTypes.string,
  onlyNumber: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/Textbox/index.js